<template>
  <div>
    <!-- <div class="role-title">{{ '角色：超级管理员' }}</div> -->
    <div class="destri-cont">
      <a-row class="search-expand user-add">
        <a-col :span="8" v-for="item in Items" :key="item.value">
          <div>{{ item.label }}</div>
          <!-- 输入 -->
          <a-input
            v-show="item.type === 'input'"
            v-model="form[item.value]"
            class="search-expand-value"
            :placeholder="
              (item.type === 'input' ? '请输入' : '请选择') + item.label
            "
          />
          <a-select
            v-show="item.type === 'selectCompanies'"
            v-model="form[item.value]"
            :placeholder="
              (item.type === 'input' ? '请输入' : '请选择') + item.label
            "
            class="search-expand-value"
            default-value="0"
          >
            <a-select-option
              v-for="opt in filters[item.selectOption]"
              :key="opt.bc_id"
              :value="opt.bc_id"
              >{{ opt.bc_name }}</a-select-option
            >
          </a-select>
        </a-col>
      </a-row>

      <div class="page-title">
        <span>可见页面</span>
        <a-checkbox
          :indeterminate="indeterminate"
          :checked="checkAll"
          @change="onCheckAllChange"
          >全选</a-checkbox
        >
      </div>
      <!-- 树形控件 -->
      <a-tree
        v-if="pages.length"
        v-model="checkedKeys"
        checkable
        :expanded-keys="expandedKeys"
        :auto-expand-parent="autoExpandParent"
        :selected-keys="selectedKeys"
        :tree-data="pages"
        @expand="onExpand"
        @select="onSelect"
        :checkStrictly="true"
        :defaultExpandAll="true"
      />
      <!-- 返回确认按钮 -->

      <a-affix :offset-bottom="40">
        <div class="dest-bottom" style="margin-top: 20px">
          <a-button @click="viewCancel()">返回</a-button>
          <a-button @click="editSubmit()" type="primary">确认</a-button>
        </div>
      </a-affix>
      <!-- <div class="dest-bottom" style="margin-top: 20px">
        <a-button @click="viewCancel()">返回</a-button>
        <a-button @click="editSubmit()" type="primary">确认</a-button>
      </div> -->
    </div>
  </div>
</template>
<script>
import Page from "@/utils/page";
import { AddRole, EditRole } from "@/api/role";
import { GetCompanies } from "@/api/device";

const editParam = ["r_id", "r_name", "r_describe", "r_right", "r_bc_id"];
const addParam = ["r_name", "r_describe", "r_right", "r_bc_id"];
export default {
  name: "RoleEdit",
  props: {
    roledata: {
      type: Object,
      default: {},
    },
    childPage: {
      type: String,
    },
  },
  data() {
    return {
      pages: Page,
      subPages: [],
      // 全选
      checkAll: false,
      indeterminate: false,
      checkedList: [],

      filters: {
        GetCompanies: [],
      },
      //输入的文本框
      Items: [
        { label: "角色名称", value: "r_name", type: "input" },
        { label: "角色描述", value: "r_describe", type: "input" },
        {
          label: "分公司",
          value: "r_bc_id",
          type: "selectCompanies",
          selectOption: "GetCompanies",
        },
      ],
      form: {},
      expandedKeys: [], //受控展开的节点
      autoExpandParent: true, //是否自动展开父节点
      checkedKeys: {},
      selectedKeys: [], //设置选中的父节点
      treeData: [],
      addShow: false,
    };
  },
  created() {
    // 获取分公司信息
    GetCompanies().then((res) => {
      // console.log("GetCompanies", res.data);
      this.filters.GetCompanies = res.data;
    });
    // this.pages = JSON.parse(JSON.stringify(Page));
    if (this.childPage === "add") {
      this.form = {};
    } else if (this.childPage === "edit") {
      this.$set(this.form, "r_id", this.roledata.r_id);
      this.$set(this.form, "r_name", this.roledata.r_name);
      this.$set(this.form, "r_describe", this.roledata.r_describe);
      this.$set(this.form, "r_bc_id", this.roledata.r_bc_id);

      this.checkedList = this.roledata.r_right.split(",");
      this.checkedKeys.checked = this.roledata.r_right.split(",");
      // console.log("this.roledata.r_right", this.roledata.r_right);
      // this.expandedKeys = this.roledata.r_right.split(",");
    }
    // console.log(this.checkedKeys);
  },
  mounted() {
    this.pages.forEach((el) => {
      this.subPages = this.subPages.concat(el.children);
      // 新加角色添加页面  打开所有节点
      let list = [];
      this.subPages.forEach((el) => {
        list.push(el.key);
        if (el.children) {
          el.children.forEach((item) => {
            list.push(item.key);
          });
          // console.log("el.children", el.children); // el.children
        }
      });
      this.expandedKeys = list;
    });
    // console.log("pages", this.pages, this.subPages);
  },
  watch: {
    checkedKeys(val) {
      // console.log("checkedKeys", val);
    },
    checkedList(val) {
      // console.log("checkedList", val);
    },
    expandedKeys(val) {
      // console.log("expandedKeys", val);
      let newList = [];
      this.checkedList.forEach((el) => {
        if (val.indexOf(el) > -1) {
          newList.push(el);
        } else {
          // console.log(el);
        }
      });
      // console.log("newList", newList);
      this.checkedKeys.checked = newList;
    },
    deep: true,
    immediate: true,
  },
  methods: {
    // // 全选
    onCheckAllChange(e) {
      this.indeterminate = false;
      this.checkAll = e.target.checked;
      // console.log(" this.subPages", this.subPages);
      if (e.target.checked) {
        let list = [];
        this.subPages.forEach((el) => {
          list.push(el.key);
          if (el.children) {
            el.children.forEach((item) => {
              list.push(item.key);
            });
            // console.log("el.children", el.children); // el.children
          }
        });
        // console.log("subPages", this.subPages);

        this.checkedList = list;
        this.checkedKeys = list;
        // console.log("checked-checkedKeys", this.checkedKeys);
      } else {
        this.checkedList = [];
        this.checkedKeys = [];
      }
    },
    // onChangeCheck(checkedList) {
    //   this.indeterminate =
    //     !!checkedList.length && checkedList.length < this.subPages.length;
    //   this.checkAll = checkedList.length === this.subPages.length;
    // },
    // 确认
    editSubmit() {
      let param = this.form;
      console.log(param);
      if (this.childPage === "add") {
        if (param.r_bc_id) {
          //添加角色
          // param.r_right = this.checkedList.join(",");
          let value = this.checkedKeys;
          // console.log("value", value);
          param.r_right = value.checked
            ? value.checked.join(",")
            : value.join(",");
          // param.r_right = value.join(",");

          // console.log(" param.r_right", param.r_right);
          const params = {
            ...param,
            verify: this.$verify(param, addParam),
          };
          AddRole(params)
            .then((res) => {
              if (res.code == "200") {
                this.$message.success(res.data);
              } else {
                this.$message.error(res.data);
              }
            })
            .then(() => {
              this.$emit("onClose");
            });
        } else {
          this.$message.error("请选择分公司");
        }
        //刷新页面
      } else if (this.childPage === "edit") {
        //修改角色
        // param.r_right = this.checkedList.join(",");
        let value = this.checkedKeys;
        // console.log("checkedKeys", this.checkedKeys);
        console.log("value", value); //选中之后传给后端的值
        let data = {
          r_right: value.checked ? value.checked.join(",") : value.join(","),
        };

        // let data = {
        //   r_right: value.join(","),
        // };
        // console.log(data);
        const param1 = Object.assign({}, param);
        const requestParameters = this.$order(param1, editParam);
        const params = {
          ...requestParameters,
          verify: this.$verify(requestParameters, editParam),
        };
        // console.log("params", params);

        EditRole(params, data)
          .then((res) => {
            if (res.code == "200") {
              this.$message.success(res.data);
            } else {
              this.$message.error(res.data);
            }
          })
          .then(() => {
            this.$emit("onClose");
          });
      }

      // this.$emit("onClose");
    },
    // 取消
    viewCancel() {
      this.$emit("onClose");
    },
    onExpand(expandedKeys) {
      console.log("onExpand", expandedKeys);
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      console.log("onCheck", checkedKeys);
      this.checkedKeys = checkedKeys;
    },
    onSelect(selectedKeys, info) {
      // console.log("onSelect", info);
      this.selectedKeys = selectedKeys;
    },
  },
};
</script>
<style lang="less" scoped>
.destri-cont {
  padding: 24px;
  background-color: #fff;
}
.dest-bottom {
  text-align: right;
  button {
    margin-left: 16px;
  }
}
.role-title {
  font-weight: 500;
  font-size: 14px;
  color: #333;
  margin-bottom: 24px;
}
.page-title {
  font-weight: 600;
  font-size: 16px;
  color: #333;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
}
.page-cont + .page-cont {
  margin-top: 40px;
}
.item-title {
  font-weight: 600;
  margin-bottom: 12px;
}
/deep/.ant-tree-checkbox-disabled {
  display: none;
}
/deep/li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper span {
  color: black;
  font-size: 14px;
}
</style>
